import {Component, Input} from '@angular/core';
import {SvgIconComponent} from "angular-svg-icon";
import {SharedModule} from "../../../shared/shared.module";
import {ActivatedRoute, Router} from "@angular/router";

@Component({
  selector: 'app-agency-dash-card',
  standalone: true,
  imports: [
    SvgIconComponent,
    SharedModule
  ],
  templateUrl: './agency-dash-card.component.html',
  styleUrl: './agency-dash-card.component.scss'
})
export class AgencyDashCardComponent {
  @Input() desc: string;
  @Input() btnText: string;
  @Input() path: string;
  @Input() icon: string;

  constructor(private router: Router) {
  }

  goTo() {
    this.router.navigate([this.path])
  }
}
